window.addEventListener('DOMContentLoaded', () => {
  const collectionDescContainer = document.querySelector('.collection-header__text');
  const readMoreBtn = document.querySelector('.read-more');

  const textLines = collectionDescContainer.innerHTML.split('<br>');
  collectionDescContainer.innerHTML = '';

  textLines.forEach((text, index) => {
    const line = document.createElement('span');
    line.innerHTML = text;
    if (index < 3) {
      line.style.display = 'inline';
    } else {
      line.style.display = 'none';
      line.classList.add('text-hidden');
    }
    collectionDescContainer.appendChild(line);
    if (index < textLines.length - 1) {
      collectionDescContainer.appendChild(document.createElement('br'));
    }
  });

  const hiddenLines = document.querySelectorAll('.text-hidden');
  if (hiddenLines.length > 0) {
    // hiddenクラスが付いているspan要素がある場合
    hiddenLines.forEach(span => {
      span.style.display = 'none';
    });

    readMoreBtn.addEventListener('click', () => {
      hiddenLines.forEach(span => {
        if (span.style.display === 'none') {
          span.style.display = 'inline';
          readMoreBtn.textContent = '閉じる';
        } else {
          span.style.display = 'none';
          readMoreBtn.textContent = '続きを読む';
        }
      });
    });
  } else {
    // hiddenクラスが付いているspan要素がない場合
    readMoreBtn.style.display = 'none';
  }
});
